import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PROMO_COLOR_MAP: Record<string, string> = {
  pink: 'from-pink-500 via-pink-600 to-rose-500',
  green: 'from-green-500 via-emerald-600 to-green-600',
  red: 'from-red-500 via-red-600 to-rose-600',
  purple: 'from-purple-500 via-violet-600 to-fuchsia-600',
  blue: 'from-blue-500 via-indigo-600 to-blue-600',
  gold: 'from-amber-400 via-yellow-500 to-amber-600',
};

interface Banner {
  enabled: boolean;
  text?: string;
  color?: string;
}

const PromoBanner = () => {
  const [banner, setBanner] = useState<Banner | null>(null);

  useEffect(() => {
    let active = true;
    fetch(`${BACKEND_URL}/api/promo-banner`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (active) setBanner(d); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!banner || !banner.enabled || !banner.text) return null;
  const grad = PROMO_COLOR_MAP[banner.color || 'pink'] || PROMO_COLOR_MAP.pink;

  return (
    <div className={`bg-gradient-to-r ${grad} text-white py-3 px-4 overflow-hidden`} data-testid="back-in-town-banner">
      <style>{`
        @keyframes pulseGlow { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.03); } }
        .promo-pulse { animation: pulseGlow 1.6s ease-in-out infinite; }
      `}</style>
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 sm:gap-3 text-center promo-pulse">
        <Sparkles className="w-5 h-5 shrink-0" />
        <p className="text-sm sm:text-lg font-extrabold tracking-wide uppercase">{banner.text}</p>
        <Sparkles className="w-5 h-5 shrink-0" />
      </div>
    </div>
  );
};

export default PromoBanner;
